export const CONSENTS = {
	IS_RULES_ACCEPTED: 'isRulesAccepted',
	IS_AD_ACCEPTED: 'isAdAccepted',
	IS_MARKET_ACCEPTED: 'isMarketAccepted',
} as const;

type ConsentKeyType = keyof typeof CONSENTS;
export type ConsentKeys = typeof CONSENTS[ConsentKeyType];
